import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
const WHATSAPP_URL = 'https://wa.me/77010346443?text=%D1%85%D0%BE%D1%87%D1%83%20%D0%B4%D0%B5%D0%BC%D0%BE%20Meelo';
export function FinalCTASection() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-24 bg-[#F8F5FF]" data-id="element-131">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-132">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E] mb-5 leading-tight" data-id="element-133">
          {t('final.title')}
        </h2>
        <p className="text-lg text-gray-500 mb-10 leading-relaxed" data-id="element-134">
          {t('final.subtitle')}
        </p>
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-4 rounded-full bg-[#7C4DFF] text-white font-semibold text-lg shadow-lg hover:bg-[#651FFF] transition-all" data-id="element-135">
          {t('final.cta')}
        </a>
      </div>
    </section>;
}